import { createContext, useContext } from "react"

import { type BokaderoUser } from "@forento/core/models/bokadero"

type UserContextValue = {
	isLoading: boolean
	user: BokaderoUser | null
	reload(options?: { clearSessionCache?: boolean }): Promise<unknown>
}

const UserContext = createContext<UserContextValue>({ isLoading: true, user: null, async reload() {} })

export const useUserContext = () => useContext(UserContext)

export const useUser = () => useUserContext().user

export default UserContext
